import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../routes';
import { clearConstructionRegistrationSettings } from '../../../../store/ducks/contracts-and-constructions/actions';
import successOrderImg from '../../../../assets/images/successOrder.svg';
import { Container } from './styles';
import { Title } from '@gerdau/hefesto/Title';
import { sendTagging } from '../../../../store/ducks/tagging/actions';

const RegistrationSuccess: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const cleanConstructionRegistrationState = () => {
    dispatch(clearConstructionRegistrationSettings());
  };

  const navigateToAccessManagement = () => {
    dispatch(
      sendTagging({
        event: 'click',
        itemName: 'button:gestao_de_usuarios',
        itemDescription:
          'contratosEObras_cadastroDeObra_revisaoDoCadastro_cadastroRealizadoComSucesso_gestaoDeUsuarios',
        screenName:
          'LG:ContratosEObras:CadastroDeObra:RevisaoDoCadastro:CadastroRealizadoComSucesso'
      })
    );

    history.push(`${ERoutes.ACCESS_MANAGEMENT}`);
  };

  useEffect(() => {
    cleanConstructionRegistrationState();

    dispatch(
      sendTagging({
        event: 'page_view',
        screenName:
          'LG:ContratosEObras:CadastroDeObra:RevisaoDoCadastro:CadastroRealizadoComSucesso',
        page: document.location.pathname
      })
    );
  }, []);

  return (
    <Container>
      <img src={successOrderImg} alt="successImg" />
      <Title level={2}>Cadastro realizado com sucesso!</Title>
      <div className="info-text" data-testid="sucessText">
        Agora você já pode criar a maquete da sua obra, anexar seus projetos e{' '}
        <br />
        implantar novos pedidos e acompanha-los. <br /> <br /> Para permitir que
        terceiros acompanhem e criem novos pedidos, basta cadastrá-los através
        do menu
        <a
          className="link-text"
          onClick={(e) => {
            e.preventDefault();
            navigateToAccessManagement();
          }}
        >
          Gestão de usuários
        </a>
        .
      </div>
    </Container>
  );
};

export default RegistrationSuccess;
